
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/image-thumbnail",
      function () {
        return require("private-next-pages/image-thumbnail/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/image-thumbnail"])
      });
    }
  